import React from "react";
import { IRoute } from "../utils/interfaces.util";

const appRoutes: Array<IRoute> = [

    {
        name: '/',
        url: '/',
        isAuth: false,
        params: [],
        content: {}
    },

    {
        name: 'components',
        url: '/components',
        isAuth: false,
        params: [],
        content: {}
    },

]

export default appRoutes;